<template>
  <div class="widget_wizard">
    <div
      class="tab-item"
      v-for="(item, index) in tabs"
      :key="index"
      :style="{ width: calcWidth(tabs, index) }"
      :class="{ active: index < active - 1 }"
    >
      <div class="tab-value" @click="onClick(item, index)">
        <span class="text">{{ item.value }}</span>
      </div>

      <div class="tab-line" v-if="index < tabs.length - 1"></div>
      <div class="tab-title" :class="{ last: index == tabs.length - 1 }">
        {{ item.title }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "widget_wizard",
  props: {
    navigate: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Number,
      default: 1,
    },
    tabs: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      active: 1,
    };
  },
  watch: {
    value(val) {
      let vm = this;
      vm.active = val;
    },
  },
  mounted() {
    let vm = this;
    vm.active = vm.value;
  },
  methods: {
    calcWidth(tabs, index) {
      if (index < tabs.length - 1) {
        return 100 / tabs.length + 100 / tabs.length / 2 + "%";
      } else {
        return "30px";
      }
    },
    onClick(tab, index) {
      let vm = this;
      if (vm.navigate) {
        vm.active = index + 1;
        vm.$emit("change", tab);
        vm.$emit("input", vm.active);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/scss/constant_valiable.scss";
.widget_wizard {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 32px;
  .tab-item {
    display: flex;
    align-items: center;
    position: relative;
    .tab-value {
      border-radius: 50%;
      border: none;
      position: relative;
      cursor: pointer;
      width: 25px;
      height: 25px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: $color_primary;
      color: $color_secondary_light;
      z-index: 22;
      .text {
        font-style: bold !important;
        font-weight: 500;
      }
      .icon {
        display: none;
      }
    }
    .tab-line {
      border-bottom: 2px solid $color_primary;
      width: calc(100% - 25px);
      position: relative;
    }
    .tab-title {
      position: absolute;
      top: 33px;
      left: -12%;
      color: #536288;
      &.last {
        left: -118%;
        min-width: 133px;
      }
    }
    &.active {
      .tab-value {
        background: $color_site_green;
        color: $color_secondary_light;
        .text {
          display: none;
        }
        .icon {
          display: block;
          width: 15px;
        }
      }
      .tab-line {
        border-bottom: 2px solid $color_site_green;
      }
    }
  }
}
</style>
